import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-ip-valuation',
  standalone:false,
  templateUrl: './ip-valuation.component.html',
  styleUrl: './ip-valuation.component.scss'
})
export class IpValuationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  uploadedFiles: any[] = [];
  allDmsFiles: any[]=[];
  apiUrl = environment.APIUrl;
  payload: any;
  @Input() id: any;
  PDSGenId: any;
  needGenData: any;
  needGenId;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  private subscriptions = new Subscription();
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  userID: any;
  categoryOptions = [
  { label: 'To Move', value: 'To Move' },
  { label: 'To Fight', value: 'To Fight' },
  { label: 'To Float', value: 'To Float' }
];
    priorityOptions = [
    { label: 'High', value: 'High' },
    { label: 'Medium', value: 'Medium' },
    { label: 'Low', value: 'Low' },
  ];
  constructor(
    private messageService: MessageService,
    private uploadService: UploadService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnInit(): void {
    this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: ['', Validators.required],
      releaseDate: ['', Validators.required],
      approvedBy: [''],
      coordinatingAgency: ['', Validators.required],
      technologyDomain: ['', Validators.required],
      valuation: ['', Validators.required],

      challengeTitle: ['', Validators.required],
      nodalOfficer: ['', Validators.required],
      problemStatement: ['', Validators.required],
      challengeBrief: ['', Validators.required],
      prototypeDevelopment: ['', Validators.required],
      requirement: ['', Validators.required],
      ipValue: [''],
      functionalAdvantages: ['', Validators.required],
      domestic: ['', Validators.required],
      substitution: ['', Validators.required],
      preliminaryScope: ['', Validators.required],
      competitiveSolution: ['', Validators.required],
      potentialMarket: ['', Validators.required],
      riskAssessment: ['', Validators.required],
      mpoQty: ['', Validators.required],
    });

    this.proposalForm = this.fb.group({
      technologyInsertion: [''],
      justificationText: [''],
      exportPotential: [''],
      objective: [''],
      existingSystem: [''],
      functionalRequirements: [''],
      contemporarySolutions: [''],
      miscellaneousInfo: [''],
      references: [''],
      keywords: [''],
      estimatedRequirement: [''],
      testingMethodology: [''],
      civilSpinOffs: [''],
      technologyReadinessLevel: [''],
      proposalExplanation: [''],
      qaAgency: [''],
      apsoConcurrence: [''],
    });

    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
   
      this.getChallenge();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.challengeForm?.enable();
        this.proposalForm?.enable();
      } else {
        this.isEditorDisabled = true;
        this.challengeForm?.disable();
        this.proposalForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      plugins:
        'advlist anchor fullscreen insertdatetime autolink link lists image code advcode mergetags wordcount ai a11ychecker advcode advtemplate advlist advtable anchor autocorrect autosave editimage image link linkchecker lists markdown media mediaembed pageembed powerpaste searchreplace table template tinymcespellchecker typography visualblocks wordcount',
      toolbar:
        'undo redo fullscreen | styles fontsizeinput lineheight |insertdatetime  bold italic strikethrough backcolor forecolor visualblocks | align bullist numlist outdent indent | advlist  table link image media pageembed | spellcheckdialog a11ycheck code | searchreplace',
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }

  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }

  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  generatePDF() {
    let payload;

      payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload.proposal_name },
          {
            key: 'Organisation',
            value: this.challengeForm.get('organisation')?.value,
          },
          { key: 'Category', value: this.challengeForm.get('category')?.value },
          {
            key: 'Release Date',
            value: this.challengeForm.get('releaseDate')?.value,
          },
          {
            key: 'Approved By',
            value: this.challengeForm.get('approvedBy')?.value,
          },
          {
            key: 'Coordinating Agency',
            value: this.challengeForm.get('coordinatingAgency')?.value,
          },
          {
            key: 'Technology Domain',
            value: this.challengeForm.get('technologyDomain')?.value,
          },
          {
            key: 'IP Valuation',
            value: this.challengeForm.get('valuation')?.value,
          },

          {
            key: 'Challenge Title',
            value: this.challengeForm.get('challengeTitle')?.value,
          },
          {
            key: 'Problem Statement',
            value: this.challengeForm.get('problemStatement')?.value,
          },
          {
            key: 'Challenge Brief/ Definition',
            value: this.challengeForm.get('pdsTitle')?.value,
          },
          {
            key: 'Future Expectation from the prototype development',
            value: this.challengeForm.get('pdsDefinition')?.value,
          },
          {
            key: 'Need/Requirement of the proposed challenge',
            value: this.challengeForm.get('qrs')?.value,
          },
          {
            key: 'IP Value',
            value: this.challengeForm.get('developmentPlatforms')?.value,
          },
          {
            key: 'Functional Advantages',
            value: this.challengeForm.get('targetPlatform')?.value,
          },
          {
            key: 'Domestic Capability Development',
            value: this.challengeForm.get('functions')?.value,
          },
          {
            key: 'Import Substitution (Reliability and Flexibility of existing source of import)',
            value: this.challengeForm.get('testProcedureOutcome')?.value,
          },
          {
            key: 'Preliminary scope of solution being developed)',
            value: this.challengeForm.get('testPlan')?.value,
          },
          {
            key: 'Global competitive nature of the problem including novelty of the solution (from user prospective)',
            value: this.challengeForm.get('endUserTrials')?.value,
          },
          {
            key: 'Potential Market for product/technology (from user perspective)',
            value: this.challengeForm.get('qaStandards')?.value,
          },
          {
            key: 'Risk Assessment',
            value: this.challengeForm.get('testSites')?.value,
          },
          {
            key: 'Pilot Procurement Plan with Minimum Pilot Order Quantity(MPQ)',
            value: this.challengeForm.get('waiverClauses')?.value,
          },
        ],
      };
    

    this.generatePDFEmitter.emit(payload);
  }
  onSubmit() {
      let formData: FormData = new FormData();

      formData.append('proposal_step', this.id);
      formData.append('organisation',this.challengeForm.get('organisation').value);
      formData.append('category', this.challengeForm.get('category').value);
      formData.append('release_date',this.challengeForm.get('releaseDate').value);
      if(this.challengeForm.get('approvedBy').value !=null){
        formData.append('approved_by',this.challengeForm.get('approvedBy').value);
      }
      formData.append('coordinated_agency',this.challengeForm.get('coordinatingAgency').value);
      formData.append('technology_domain',this.challengeForm.get('technologyDomain').value);
      formData.append('ip_status',this.challengeForm.get('valuation').value);
      

      formData.append('title', this.challengeForm.get('challengeTitle').value);
      formData.append('nodal_officer',this.challengeForm.get('nodalOfficer').value);
      formData.append('problem_statement', this.challengeForm.get('problemStatement').value);
      formData.append('challenge_brief',this.challengeForm.get('challengeBrief').value);
      formData.append('prototype_development',this.challengeForm.get('prototypeDevelopment').value);
      formData.append('requirement',this.challengeForm.get('requirement').value);
      formData.append('ip_value', this.challengeForm.get('ipValue').value);
      formData.append('functional_advantages',this.challengeForm.get('functionalAdvantages').value);
      formData.append('domestic', this.challengeForm.get('domestic').value);
      formData.append('substitution',this.challengeForm.get('substitution').value);
      formData.append('preliminary_scope',this.challengeForm.get('preliminaryScope').value);
      formData.append('competitive_solution',this.challengeForm.get('competitiveSolution').value);
      formData.append('potential_market',this.challengeForm.get('potentialMarket').value);
      formData.append('risk_assessment',this.challengeForm.get('riskAssessment').value);
      formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

         if (this.draftSotrFile) {
        formData.append('pds', this.draftSotrFile);
      }

      if (this.supportingDocsFiles) {
        // this.supportingDocsFiles.forEach(file => {
        formData.append('pru', this.supportingDocsFiles); // Change key name if needed
        // });
      }

      if (this.PDSGenId) {
        const sub = this.apiService
          .putAPI(`/idex/challenges/${this.PDSGenId}/`, formData)
          .subscribe({
            next: (res: any) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Challenge updated successfully.',
              });
            this.fileUpload.clear();
            this.draftSotrUpload.clear();
              this.getChallenge();
            },
            error: (err) => {},
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.apiService
          .postAPI(`/idex/challenges/`, formData)
          .subscribe({
            next: (res: any) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Challenge added successfully.',
              });
              this.getChallenge();
            },
            error: (err) => {},
          });
        this.subscriptions.add(sub);
      }
    
  }

  getChallenge() {
    const sub = this.apiService
      .getAPI(
        `/idex/ip/valuation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe((resp: any) => {
        let res = resp.challenge;
        this.needGenData = resp.challenge;
        this.challengeForm.patchValue({
          organisation: res.organisation,
          category: res.category,
          releaseDate: res.release_date,
          approvedBy: res.approved_by,
          coordinatingAgency: res.coordinated_agency,
          technologyDomain: res.technology_domain,
          valuation: res.ip_status,

          challengeTitle: res.title,
          nodalOfficer: res.nodal_officer,
          problemStatement: res.problem_statement,
          challengeBrief: res.challenge_brief,
          prototypeDevelopment: res.prototype_development,
          requirement: res.requirement,
          ipValue: res.ip_value,
          functionalAdvantages: res.functional_advantages,
          domestic: res.domestic,
          substitution: res.substitution,
          preliminaryScope: res.preliminary_scope,
          competitiveSolution: res.competitive_solution,
          potentialMarket: res.potential_market,
          riskAssessment: res.risk_assessment,
          mpoQty: res.mpo_qty,
        });
        if (res.status) {
          this.PDSGenId = res?.id;
        }
      });
    this.subscriptions.add(sub);
  }

// this is use for upload Document table 
  onDocumentUpload(data:any){
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step',this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next:(res:any)=>{
        console.log('>>>>>>res need upload data',res);
        // ✅ Reset the form inside the child component
        // this.uploadDocumentComp.uploadForm.reset();
        // console.log('🧹 Form reset successfully after upload');
      },
      // next: (event: HttpEvent<any>) => {
      //   if (event.type === HttpEventType.UploadProgress && event.total) {
      //     this.uploadProgress = Math.round((event.loaded / event.total) * 100);
      //   } else if (event.type === HttpEventType.Response) {
      //     console.log('✅ Upload successful:', event.body);
      //     this.uploadProgress = 0;
      //   }
      // },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });
    
  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res:any)=>{
          console.log('delete uploadData',res);
      },
      error: (err) => {
          console.error('❌ Upload failed:', err);
        }
    })

    // Optionally call delete API
  }

}
